<template>
  <div class="schedule-page-header">
    <h3 class="title">{{ this.$t("schedule.main_page_title") }}</h3>
  </div>
</template>

<script>
export default {
  name: "schedule-page-header",
  methods: {}
};
</script>

<style lang="scss" scoped>
.schedule-page-header {
  display: flex;
  align-items: center;
  padding-left: 15px;

  h3 {
    width: fit-content;
    margin: 0;

    font-size: 1.5rem;
    font-weight: 500;
  }
}
</style>
